export default __webpack_public_path__ + "static/media/allina screen.5b955ef5.png";